import { injectable, inject } from "@launchtray/tsyringe-async";
import { Viewable, PromiseCompletionSource } from "scene-manager";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { InjectableInterfaces } from "../../../composition/InjectableInterfaces";
import { ForceRotateView } from "./views/ForceRotateView";
import { SpineResourcesPackage } from "../../../common/resources/SpineResourcesPackage";

@injectable()
export class ForceRotateScene extends Viewable<void> {
    public constructor(
        spineResources: SpineResourcesPackage,
        @inject(InjectableInterfaces.ICanvasScaler) canvasScaler: ICanvasScaler
    ) {
        super();
        const pcs = new PromiseCompletionSource<void>();
        this.view = new ForceRotateView(spineResources, canvasScaler, pcs);
        pcs.result.then(
            () => {
                this.operationControls.complete();
            },
            (reason: unknown) => {
                this.operationControls.error(reason);
            }
        );
    }
}
